// extracted by mini-css-extract-plugin
module.exports = {"CollectionData":"CollectionData_CollectionData__3ODXQ"};